import { render, staticRenderFns } from "./ProductsReportTable.vue?vue&type=template&id=2332c617&scoped=true"
import script from "./ProductsReportTable.vue?vue&type=script&lang=js"
export * from "./ProductsReportTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsReportTable.vue?vue&type=style&index=0&id=2332c617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2332c617",
  null
  
)

export default component.exports